<template>
      <el-dialog
        :close-on-click-modal="false"
        v-dialogDrag
        title="业绩提成"
        :visible.sync="wageDialogVisible"
        width="800px"
        append-to-body
      >
        <div style="font-size: 20px; text-align: center; margin: 10px 0">
          编码:{{ wageForm.projectNum }} 名称:
          {{ wageForm.projectName }}
        </div>
        <hr />
        <small>输入值大于1为固定金额 , 输入值小于等于1为百分比</small>
        <table
          class="table"
          border="0"
          width="500"
          cellspacing="0"
          cellpadding="0"
        >
          <tr class="tr">
            <th colspan="2"></th>
            <th v-show="wageForm.directConsumption == 0">销售（次）</th>
            <th>美容师（次）</th>
            <th>美发师（次）</th>
            <th>技师（次）</th>
            <th>助理（次）</th>
          </tr>
          <tr>
            <th rowspan="2">业绩</th>
            <th>现付</th>
            <td v-show="wageForm.directConsumption == 0">
              <span v-show="!editShow">{{ wageForm.salesAchievement }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.salesAchievement"
              />
            </td>
            <td>
              <span v-show="!editShow">{{ wageForm.achievementLarge }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.achievementLarge"
              />
            </td>
            <td>
              <span v-show="!editShow">{{
                wageForm.achievementZhonggong
              }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.achievementZhonggong"
              />
            </td>
            <td>
              <span v-show="!editShow">{{
                wageForm.achievementTechnician
              }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.achievementTechnician"
              />
            </td>
            <td>
              <span v-show="!editShow">{{ wageForm.achievementSmall }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.achievementSmall"
              />
            </td>
          </tr>

          <tr>
            <th>卡付</th>
            <td v-show="wageForm.directConsumption == 0">
              <span v-show="!editShow">{{
                wageForm.cardSalesAchievement
              }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.cardSalesAchievement"
              />
            </td>
            <td>
              <span v-show="!editShow">{{
                wageForm.cardAchievementLarge
              }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.cardAchievementLarge"
              />
            </td>
            <td>
              <span v-show="!editShow">{{
                wageForm.cardAchievementZhonggong
              }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.cardAchievementZhonggong"
              />
            </td>
            <td>
              <span v-show="!editShow">{{
                wageForm.cardAchievementTechnician
              }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.cardAchievementTechnician"
              />
            </td>
            <td>
              <span v-show="!editShow">{{
                wageForm.cardAchievementSmall
              }}</span>
              <input
                oninput="this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,4})\d*/,'$1$2$3')"
                pattern="[0-9]*\.?[0-9]1{0,4}"
                v-show="editShow"
                v-model="wageForm.cardAchievementSmall"
              />
            </td>
          </tr>
        </table>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="wageDialogVisible = false" plain>取 消</el-button>
        </span>
      </el-dialog>
</template>

<script>
export default {
  data() {
    return {
        wageDialogVisible:false,
        editShow:false,
        wageForm:{}
    }
  },
  methods: {
    show(row){
        this.wageForm = {...row}
        this.wageDialogVisible = true
    }
  },
}
</script>
<style scoped>
.table{
  width: 100%;
}
.project .el-col {
  width: 450px;
}

.project .wage {
  position: relative;
}

.project .table input {
  width: 55px;
  height: 30px;
  border: none;
  color: #5a5b5c;
  border-color: #99a9bf;
}

.project .table .demo-table-expand {
  font-size: 0;
}

.project .table .demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.project .table .el-col {
  border: 1px solid #99a9bf;
  height: 500px;
  width: 300px;
  overflow: hidden;
}

.project .table .demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 20%;
}

.project .table .el-table {
  display: none;
}

.project .table {
  border-right: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
  background: white;
  width: 95%;
  height: 300px;
  margin: 5px auto;
  text-align: center;
  box-shadow: 5px 5px 5px #e7e7e7;
}

.table td,
.table tr,
.table th {
  border-left: 1px solid #e7e7e7;
  border-top: 1px solid #e7e7e7;
}

.project .table .tr th {
  background: #e7e7e7;
  border-right: 1px solid white;
}

.table td {
  overflow: hidden !important;
  width: 100px;
  height: 60px;
}

.project .but2 {
  position: absolute;
  bottom: 20px;
  left: 40px;
}

.project .el-table th {
  padding: 5px 0;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

@media (max-width: 1000px) {
  .el-table__fixed-right {
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/eashier/errorOrder/component/index.vue